import { Input } from "antd";

import React from "react";
import { useHistory } from "react-router-dom";
import styled from "styled-components";

import { useDispatch } from "~/Action";
import * as Button from "~/Button";
import * as Color from "~/Color";
import { Company } from "~/Company";
import { Dashboard } from "~/Dashboard";
import * as Driver from "~/Driver";
import { FilterRow } from "~/Filter";
import * as Layout from "~/Layout";
import * as Preferences from "~/Preferences";
import { Remote } from "~/Remote";
import { Route as GenericRoute } from "~/Route";
import { Search } from "~/Search";

import { AddEdit } from "./AddEdit";

export function Overview() {
  const dispatch = useDispatch();
  const updateFilters = Preferences.Put.use();
  const userPreferences = Remote.toUndefined(Preferences.Get.use()) ?? {};

  const [match, setMatch] = React.useState<Search.Match>(
    Search.Match.anything()
  );

  const onFilterByBranch = (
    filteredBranchIds: Company.Branch.Branches.BranchIDs
  ) => {
    dispatch(Driver.Filter.Action.Branch.Updated.create(filteredBranchIds));
    dispatch(Driver.Action.Filtered.Requested.create());
    const filterPreferences = {
      [`${Preferences.preferenceKey("branchFilter")}`]: filteredBranchIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Drivers Table",
      "branchFilter"
    );
  };

  const onFilterWorkReportingLocation = (
    filteredWorkReportingLocationIds: Driver.Filter.Filter
  ) => {
    dispatch(
      Driver.Filter.Action.Location.Updated.create(
        filteredWorkReportingLocationIds
      )
    );
    dispatch(Driver.Action.Filtered.Requested.create());
    const filterPreferences = {
      [`${Preferences.preferenceKey(
        "locationFilter"
      )}`]: filteredWorkReportingLocationIds,
    };
    updateFilters.request(
      {
        ...userPreferences,
        ...filterPreferences,
      },
      "Drivers Table",
      "locationFilter"
    );
  };

  return (
    <Layout.Page.Component all>
      <FilterRow>
        <Company.Branch.Branches.Filter.Component onFilter={onFilterByBranch} />
        <Company.Location.Filter.Component
          onFilter={onFilterWorkReportingLocation}
        />
      </FilterRow>
      <Layout.Section.Component>
        <Layout.Section.Header.Component
          Left={() => (
            <Input.Search
              allowClear
              style={{ width: 200 }}
              placeholder="Search drivers"
              defaultValue={Search.Match.toString(match)}
              onSearch={(search) => setMatch(Search.Match.string(search))}
            />
          )}
          Right={() => <Overview.AddDriver />}
        >
          <Layout.Section.Header.Title>Drivers</Layout.Section.Header.Title>
        </Layout.Section.Header.Component>
        <Overview.StatusCount />
        <Driver.Table {...match} />
      </Layout.Section.Component>
    </Layout.Page.Component>
  );
}

export namespace Overview {
  export namespace Route {
    export const definition = () => "/drivers" as const;
    export const initialDefinition = () => ["/drivers", "/"] as const;
    export const href = () => definition();
    export const use = () => GenericRoute.use(href());
  }

  export const AddDriver = () => {
    const history = useHistory();
    return (
      <Button.Component
        primary
        action
        title="Add driver"
        icon="$icon_add_circle_line"
        onClick={() => history.push(AddEdit.Route.href())}
      />
    );
  };

  export function StatusCount() {
    return (
      <StatusCount.Container>
        <Dashboard.DriverSummary.Content filtered />
      </StatusCount.Container>
    );
  }

  export namespace StatusCount {
    export const Container = styled.div`
      border-bottom: 1px solid ${() => Color.veryWhiteGrey()};
    `;
  }
}
